import axios from "axios";

const BASE = process.env.REACT_APP_BASE_API_URL;

const get = async (path) => {
  try {
    const response = await axios.get(`${BASE}${path}`);
    return response.data;
  } catch (err) {
    const status = err.response?.status;
    const message = `Failed to fetch ${path}${status ? ` (${status})` : ""}`;
    throw new Error(message);
  }
};

export const getEducation = () => get("/api/portfolio/education/");
export const getResearch = () => get("/api/portfolio/research/");
export const getExperience = () => get("/api/portfolio/experience/");
export const getProjects = () => get("/api/portfolio/projects/");
export const getResearchInterests = () =>
  get("/api/portfolio/research-interests/");
export const getResearchPillars = () => get("/api/portfolio/research-pillars/");
export const getPresentations = async (params = {}) => {
  try {
    const response = await axios.get(`${BASE}/api/blogs/presentations/`, {
      params,
    });
    return response.data;
  } catch (err) {
    const status = err.response?.status;
    throw new Error(
      `Failed to fetch presentations${status ? ` (${status})` : ""}`,
    );
  }
};
